import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';

const Product = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        //dotsClass: "button__bar",
        customPaging: i => (
            <button className="slick-dot"></button>
        ),
    };

    const urlImg = "https://dev.jftheskinspecialist.com/images/news/";

    const [productImages, SetProductImages] = useState([]);

    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/slider')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetProductImages(datas.data);
            });
    }, []);

    return (
        <div className="max-w-12xl mx-auto">
            <div className="relative overflow-y-scroll" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                <Slider {...settings}>
                    {productImages.map((image, index) => (
                        <div key={index}>
                            {image.featured_image != null ? 
                                <img src={ urlImg+''+image.featured_image} alt="" className="w-full" style={{ height: 'auto' }} />
                            :
                                <div className="w-full">
                                    <iframe
                                        src={image.meta_og_url}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="Embedded youtube"
                                        className="w-auto min-w-full lg:h-[630px] max-w-none"
                                    />
                                </div>
                             }
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default Product;
